import React from "react";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";

const CorpIntro = ({ portfolio }) => {
	const { t } = useTranslation();

	return (
		<li className="detail-info-item">
			<h4 className="detail-info-title">
				{portfolio.name} {t("pages.portfolio.PortfolioView.components.CorpIntro.intro")}
			</h4>
			{portfolio.introduction ? (
				<p className="company-intro">{portfolio.introduction}</p>
			) : (
				<div className="c__noData">
					<CautionIcon />
					<p className="main">
						{t("pages.portfolio.PortfolioView.components.CorpIntro.wouldIntro")}
					</p>
				</div>
			)}
			{/* <div className="c__noData">
        <CautionIcon />
        <p className="main">기업 소개를 작성해주세요.</p>
      </div> */}
		</li>
	);
};

export default CorpIntro;
